<template>
  <div>
    <admin-layout>
      <admin-sidebar-links slot="sidebar-links" />
      <router-view class="view" />
    </admin-layout>
  </div>
</template>

<script>
import AdminLayout from 'components/AdminLayout';
import AdminSidebarLinks from 'components/AdminSidebarLinks';

export default {
  components: {
    AdminLayout,
    AdminSidebarLinks,
  },
};
</script>
